export default __webpack_public_path__ + "static/media/thnx.a3a7e51c.gif";